import { render, staticRenderFns } from "./Movimientos-de-caja.vue?vue&type=template&id=a472bb28&scoped=true"
import script from "./Movimientos-de-caja.vue?vue&type=script&lang=js"
export * from "./Movimientos-de-caja.vue?vue&type=script&lang=js"
import style0 from "./Movimientos-de-caja.vue?vue&type=style&index=0&id=a472bb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a472bb28",
  null
  
)

export default component.exports